<script setup>

  const props = defineProps({
    size: {
      type: String,
      default: "default"
    },
    showText: {
      type: Boolean,
      default: true
    }
  });
</script>
<template>
  <div
    class="jwx-loader"
    :data-size="props.size"
  >
      <div class="jwx-circle-loader"></div>
      <p v-if="props.showText && props.size !== 'sm'" class="jwx-loader__text">Loading</p>
  </div>
</template>